// Material Kit 2 React pages
import EastCoast from "pages/LandingPages/Locations/EastCoast";

export default function EastCoastPage() {
  return <EastCoast />;
}
